import { SignedIn, SignedOut } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useFooterPromoUrl } from '../hooks/use-custom-events';
import { fetchJson } from '../util/xhr';
import { Copyright } from './Copyright';
import { Disclaimer } from './Disclaimer';
import { PanicBanner } from './PanicBanner';
import { PromoBanner } from './PromoBanner';

export function Footer() {
  const [promoLink, setPromoLink] = useState('');
  useFooterPromoUrl({ onShow: setPromoLink });
  const status = useQuery({
    queryKey: ['status'],
    queryFn: async () => fetchJson('api/status'),
    refetchInterval: 20 * 1000,
  });
  return (
    <footer className="flex flex-col justify-end">
      <div className="pb-2">
        <SignedOut>
          <Copyright />
        </SignedOut>
        <SignedIn>
          <Disclaimer />
        </SignedIn>
      </div>
      {promoLink && <PromoBanner to={promoLink} />}
      {status.data?.panic && <PanicBanner />}
    </footer>
  );
}
